var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncAppleHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "185px",
    height: "48px",
    viewBox: "0 0 185 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wires-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GlidePath_-Height-Copy-4",
    transform: "translate(-102.000000, -470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(102.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#F4F4F4",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 184,
    height: 47,
    rx: 23.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Sync-from-HealthKit",
    fontFamily: "AvenirNext-Regular, Avenir Next",
    fontSize: 13,
    fontWeight: "normal",
    "line-spacing": 16,
    fill: "#FA4242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 44,
    y: 29
  }, "Sync from HealthKit"))), /*#__PURE__*/React.createElement("path", {
    d: "M31.0108262,19.9387572 C31.0101934,19.9381376 31.0095371,19.9375401 31.0090215,19.9370533 C29.6885492,18.6897364 27.539442,18.6892938 26.2183134,19.9359911 C26.2181963,19.9361239 26.2180088,19.9362788 26.2178681,19.9364116 C26.2177041,19.9365886 26.2174697,19.9367877 26.2172822,19.9369648 L26.0006722,20.1414985 L25.7840388,19.9369648 C25.1440996,19.3327462 24.2932224,19 23.3882043,19 C22.4831629,19 21.6323325,19.3327683 20.9923698,19.9369648 C20.3524306,20.5411833 20,21.3445141 20,22.1989839 C20,23.0534757 20.3524306,23.8567844 20.9923933,24.4610251 L25.6578979,28.8659456 C25.7488356,28.9518041 25.8721406,29 26.0007191,29 C26.1292976,29 26.2526026,28.951782 26.3435169,28.8659456 L31.0089043,24.4611136 C32.3296578,23.2146597 32.3304313,21.1862511 31.0108262,19.9387572 Z",
    id: "Combined-Shape",
    fill: "#FA4242",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncAppleHealth);
export default __webpack_public_path__ + "static/media/sync-apple-health.25184a21.svg";
export { ForwardRef as ReactComponent };